export default{
  Read(action,onsuccess,onfailed,self){
    // console.log(self)
    return {
        data : {
          // query:state.query,
          AuthorizationToken : self.props.UserReducer.token,
          // ordering:ordering,
          AssetAlias:self.props.match.params.Alias,
        },
        action : action,
        // Reducer: props.PhotoReducer,
        UserReducer: self.props.UserReducer,
        // RunRedux : props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        // permission_needed:permission_needed,
        self:self,
    }
  },
  Delete(action,onsuccess,onfailed,self=null){
    // console.log(state)
    return {
        data : {
          AuthorizationToken : self.props.UserReducer.token,
          Alias: self.DeleteParams.Alias,
        },
        action : action,
        // Reducer: props.PhotoReducer,
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        // permission_needed:permission_needed,
        self:self,
    }
  },
  Open(action,onsuccess,onfailed,self=null){
    // console.log(state)
    return {
        data : {
          AuthorizationToken : self.props.UserReducer.token,
          Alias: self.OpenParams.Alias,
          FileName : self.OpenParams.FileName,
        },
        action : action,
        // Reducer: props.PhotoReducer,
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        // permission_needed:permission_needed,
        self:self,
    }
  },
  Register(action,onsuccess,onfailed,self=null){
    // console.log(state)
    return {
        // data : {
          AuthorizationToken : self.props.UserReducer.token,
        //   Asset: self.RegisterParams.Asset,
        //   File: self.RegisterParams.File,
        //   Filename : self.RegisterParams.Filename
        // },
        data: self.RegisterParams.File,
        FileName : self.RegisterParams.Filename,
        action : action,
        // Reducer: props.PhotoReducer,
        UserReducer: self.props.UserReducer,
        RunRedux : self.props.RunRedux,
        onfailed : onfailed,
        onsuccess : onsuccess,
        // permission_needed:permission_needed,
        self:self,
    }
  },
}



// WEBPACK FOOTER //
// ./src/App/asset/document/helper/object.request.props.js